module.exports = __webpack_public_path__ + "img/rebang.ae1cc894.svg";